// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"33717":"9210f3f362c9fd90","62512":"cb32e7e6743d0063"}[chunkId] + ".css";
};